import { render, staticRenderFns } from "./BlockedPage.vue?vue&type=template&id=39928635&scoped=true"
import script from "./BlockedPage.vue?vue&type=script&lang=js"
export * from "./BlockedPage.vue?vue&type=script&lang=js"
import style0 from "./BlockedPage.vue?vue&type=style&index=0&id=39928635&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39928635",
  null
  
)

export default component.exports